import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedReorder202603: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_reorder_202603",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-03-01",
  endDate: "2026-03-31",
  impressions: 11515,
  clicks: 236,
  adsSpendDollars: 716,
  budgetDollars: 900,
  salesDollars: 10484,
  bestEstimateRoas: 14.64,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.8,
  reorderConversions: 35,
  dataAvailableAtDate: "2026-04-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
